export const url = Object.freeze({
  // baseUrl: "https://staging.smartbuildingsecurity.com/api"
  baseUrl: "/api"
});
